/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SmtpOAuthAddresses {
    Azure = 'https://graph.microsoft.com',
    Google = 'https://gmail.googleapis.com',
}
